.infoText {
  color: var(var(--chart-300-icon-buttons));
}

gz-info-box {
  padding-left: calc(var(--spacer) * -1);
}

.form-field-info-text {
  padding-top: calc(var(--spacer) * 2);
}

gz-dropdown {
  --form-field-input-width: 400px;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}
